import { connect } from 'react-redux';
import NotFound from '../../components/notFound/NotFound';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
